(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/triss-subscription/assets/javascripts/use-active-suspension.js') >= 0) return;  svs.modules.push('/modules/triss-subscription/assets/javascripts/use-active-suspension.js');
"use strict";

const {
  useState,
  useEffect,
  useCallback
} = React;
const {
  getActiveSuspensionsAsync
} = svs.trissSubscription.utils;
const useActiveSuspension = () => {
  const [activeSuspensions, setActiveSuspensions] = useState(false);
  const getSuspensions = useCallback(async () => setActiveSuspensions(await getActiveSuspensionsAsync()), [setActiveSuspensions]);
  useEffect(() => {
    !activeSuspensions && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && getSuspensions();
  }, [activeSuspensions, getSuspensions]);
  return {
    hasActiveSuspension: (activeSuspensions === null || activeSuspensions === void 0 ? void 0 : activeSuspensions.length) > 0
  };
};
setGlobal('svs.ticketSubscription', {
  useActiveSuspension
});

 })(window);